import { IdConnectConfiguration } from '@idConnect/types';
import { getIdGraphData } from './getIdGraphData';

export const getIdGraphEntry = (
  entryKey: string | Array<string> | undefined,
  idConnectConfiguration: IdConnectConfiguration,
) => {
  const idGraphData = getIdGraphData(entryKey, idConnectConfiguration);

  return idGraphData.isSuccessful ? idGraphData.data : idGraphData.errorMessage;
};
